import { onMounted, onUnmounted, ref } from "@vue/composition-api";
import { IS_BROWSER } from "@/lib/browserUtils";

export default function useOrientation() {
  const isLandscape = ref(false);

  const handleOrientation = () => {
    let angle = 0;

    if (IS_BROWSER) {
      if (window.screen.orientation) {
        angle = window.screen.orientation.angle;
      } else if (typeof window.orientation === "number") {
        angle = window.orientation;
      }
    }

    isLandscape.value = Math.abs(angle) === 90 || Math.abs(angle) === 270;
  };

  onMounted(() => {
    window.addEventListener("orientationchange", handleOrientation);
    handleOrientation();
  });
  onUnmounted(() => {
    window.removeEventListener("orientationchange", handleOrientation);
  });

  return { isLandscape };
}
